(() => {
  function setup(root = document) {
    root.querySelectorAll('[data-yh-hero]').forEach(hero => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const video = hero.querySelector('[data-yh-video]');
      const toggle = hero.querySelector('[data-yh-video-toggle]');
      const mobile = matchMedia('(max-width: 999px)');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = false;
      const showState = () => {
        toggle.setAttribute('aria-label', video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        toggle.innerHTML = video.paused ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 11 7-11 7Z"/></svg>' : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6v12M15 6v12"/></svg>';
      };
      const play = () => {
        if (!video.getAttribute('src')) video.src = video.dataset.src;
        video.muted = true;
        video.play().catch(showState);
      };
      const sync = () => {
        toggle.hidden = !mobile.matches;
        if (!mobile.matches || reduce.matches || paused) video.pause(); else play();
        showState();
      };
      toggle.addEventListener('click', () => { paused = !video.paused; if (paused) video.pause(); else play(); });
      video.addEventListener('play', showState);
      video.addEventListener('pause', showState);
      video.addEventListener('error', () => { toggle.hidden = true; });
      mobile.addEventListener('change', sync); reduce.addEventListener('change', sync); sync();
    });
    root.querySelectorAll('[data-yh-product-filters]').forEach(filters => {
      filters.hidden = false;
      if (filters.dataset.ready) return;
      filters.dataset.ready = 'true';
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-product-filter]');
        if (!button) return;
        const section = filters.closest('.yh-product-section');
        const cards = [...section.querySelectorAll('[data-yh-card]')];
        const category = button.dataset.productFilter;
        filters.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        cards.forEach(card => { card.hidden = category !== 'all' && card.dataset.category !== category; });
        const count = cards.filter(card => !card.hidden).length;
        section.querySelector('.yh-product-count').textContent = String(count);
        section.querySelector('#filter-status').textContent = `${button.textContent.trim()}: ${count}`;
        if (section.getBoundingClientRect().top < 0) section.scrollIntoView({block:'start'});
      });
      filters.querySelector('[aria-pressed="true"]')?.click();
    });
  }
  document.addEventListener('click', event => {
    const swatch = event.target.closest('[data-yh-swatch]');
    if (!swatch || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const card = swatch.closest('[data-yh-card]');
    const img = card?.querySelector('[data-yh-card-image]');
    // Without that variant's own image, follow its product link instead of
    // labelling the previous color's picture as the newly selected color.
    if (!img || !swatch.dataset.image) return;
    event.preventDefault();
    card.querySelectorAll('[data-yh-product-link]').forEach(a => { a.href = swatch.href; });
    card.querySelectorAll('[data-yh-swatch]').forEach(a => { if (a === swatch) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
    card.querySelectorAll('quick-add-component').forEach(qv => { qv.dataset.productUrl = swatch.href; });
    img.removeAttribute('srcset'); img.src = swatch.dataset.image; img.alt = swatch.dataset.imageAlt || img.alt;
    card.querySelector('[data-yh-price]').textContent = swatch.dataset.price;
    const compare = card.querySelector('[data-yh-compare]');
    compare.textContent = swatch.dataset.compare; compare.hidden = !swatch.dataset.compare;
    const saving = card.querySelector('[data-yh-saving]');
    if (saving) {
      const savingText = (swatch.dataset.saving || '').trim();
      saving.textContent = savingText;
      saving.hidden = !savingText;
    }
  });
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
